import React from 'react';

import Button from '@/common/components/ui/Button';
import StandardInputText from '@/common/components/input/StandardInputText';
import StandardInputTextarea from '@/common/components/input/StandardInputTextarea';
import { AddIcon, DeleteIcon } from '@/assets/icons/button';

import { UnitBuilderData } from 'course-types';

interface Props {
  units: Array<UnitBuilderData>;
  onChange: (field: string, value: string, unitIndex?: number, subunitIndex?: number) => void;
  onRemoveUnit: (index: number) => void;
  onAddUnit: () => void;
}

const UnitsStep: React.FC<Props> = ({ units, onChange, onRemoveUnit, onAddUnit }) => (
  <div className='flex flex-col gap-2 w-full'>
    <div className='flex flex-col gap-1 bg-surface_gray_200 rounded-lg p-3 border border-border_gray_300'>
      <p className='text-base'>Add units to your course.</p>
      <p className='text-sm text-text_gray_900'>
        Units are the main sections of your course. Each unit can contain multiple subunits.
      </p>
    </div>

    <div className='max-h-[35vh] min-h-[200px] overflow-y-auto'>
      {units.map((unit, index) => (
        <div
          key={index}
          className='mb-2 last:mb-0 bg-surface_gray_200 rounded-lg p-3 border border-border_gray_300'
        >
          <div className='flex justify-between items-center mb-2'>
            <h3 className='text-base font-semibold'>Unit {index + 1}</h3>
            <Button text={true} onClick={() => onRemoveUnit(index)} delete>
              <DeleteIcon className='w-[20px] h-[20px]' />
            </Button>
          </div>

          <div className='flex flex-col gap-2'>
            <StandardInputText
              id={`unit-${index}-name`}
              label='Unit Name'
              isRequired={true}
              value={unit.name}
              onChange={(e) => onChange('name', e.target.value, index)}
            />
            <StandardInputTextarea
              id={`unit-${index}-description`}
              label='Unit Description'
              value={unit.description || ''}
              onChange={(e) => onChange('description', e.target.value, index)}
              rows={2}
            />
          </div>
        </div>
      ))}
    </div>

    <Button text={true} onClick={onAddUnit} className='w-fit'>
      <AddIcon className='w-[20px] h-[20px] mr-1' /> Add Unit
    </Button>
  </div>
);

export default UnitsStep;
